import React, {useContext, useState} from 'react';
import Header from '../../Utils/Header'
import Footer from '../../Utils/Footer'
import PrestadorContext from '../../Context/PrestadorContext/PrestadorContext';
import { Link } from "react-router-dom";
import Parser from 'html-react-parser';
import { htmlJava, textedJson, hl7Json, htmlPhp, htmlRuby, htmlGo, htmlC, htmlSwift, htmlNode, lenguajes1, lenguajes2, Numeros } from '../../Utils/Lenguajes';


const PrestadorAPI = () => {
    
    //EXTRAER CONTEXT PRESTADORES
    const prestadores_context = useContext(PrestadorContext);
    const { Consulta_Prestadores_F,Datos_Metodo_F,Json_Resp_F, Respuesta_Prestadores_F, consulta_prestadores, json_resp, datos_metodo_prestador, respuesta_api_prestadores } = prestadores_context;
    
    const usuario = localStorage.getItem('usuario')

    if(usuario === "" || usuario === null){
        
        localStorage.clear();
        window.location.replace('/');
    }

    const ConsultaApi = e =>{

        if(Metodos === 0){
            
            if(datos_metodo_prestador.rutpres !== undefined && datos_metodo_prestador.rutpres !== ""){
                Consulta_Prestadores_F(true)
                setAlertaProbar(false)
            }else{
                setAlertaProbar(true)
            }
        }else if(Metodos === 1){
            
            if(datos_metodo_prestador.nroregistro !== undefined && datos_metodo_prestador.nroregistro !== ""){
                Consulta_Prestadores_F(true)
                setAlertaProbar(false)
            }else{
                setAlertaProbar(true)
            }
        }
    }
  
    const [ValueRut, setValueRut] = useState('12950968')
    const [ValueNro, setValueNro] = useState('334583')
    //FUNCIÓN PARA OBTENER LA DATA INGRESADA
    const MetodoPrestador = e =>{
        e.preventDefault(); 

        if(e.target.name === 'rutpres'){
            setValueRut(e.target.value)
            setValueNro('334583')
        }else{
            setValueNro(e.target.value)
            setValueRut('12950968')
        }
        
        if(isNaN(e.target.value) === false){
            Datos_Metodo_F({
                ...datos_metodo_prestador,
                [e.target.name]: e.target.value
            });
        }
    }

    const ChangeFormato = e =>{
        e.preventDefault();

        Datos_Metodo_F({
            ...datos_metodo_prestador,
            [e.target.name]: e.target.value
        });

    }

    const [Metodos, setMetodos] = useState(0)

    const ChangeMetod = e => {

        if(Metodos === 0){
            setMetodos(1)
            Datos_Metodo_F(0)
            document.getElementById('form-probar').reset();
        }else if(Metodos === 1){
            setMetodos(0)
            Datos_Metodo_F(0)
            document.getElementById('form-probar').reset();
        }

    }

    const ProbarMetodo = e => {

        Json_Resp_F("Realice una prueba.")
        Respuesta_Prestadores_F("")
        Datos_Metodo_F({
            formato_json: "json"
        })
        document.getElementById('form-probar').reset();
    }

    const [AlertaProbar, setAlertaProbar] = useState(false)
    
    const [FormatJson, setFormatJson] = useState(0)
    
    const FormatoJson = e =>{
        e.preventDefault();
        if(FormatJson === 0){
            setFormatJson(1)
        }else{
            setFormatJson(0)
        }
    }
    const apikey = localStorage.getItem('apikey')

    const [Format, setFormat] = useState('json')
    const [ClassFormat, setClassFormat] = useState(true)

    const ChangeFormat = e =>{
        if(Format === 'json'){
            setFormat('hl7')
            setClassFormat(false)
        }else{
            setFormat('json')
            setClassFormat(true)
        }
    }

    // FRAGMENTOS DE CODIGO
    const [Lenguaje, setLenguaje] = useState("cURL")
    

    return ( 

        <>
            <Header/>

            <div className="container-fluid bg-light">
                <div className="container">
                    <div className="row">

                        <div className="col-12 mt-3">
                            <Link to='/'>
                                <p className="volver">{'< VOLVER AL CENTRO DE APIS'}</p>
                            </Link>
                        </div>
                        
                        <div className="col-12 mt-3">
                            <h2 className="lead d-inline">PRESTADORES</h2>
                            
                            <button type="button" className="btn btn-primary mb-2  mx-3">V.1</button>
                            <small className="d-block">Datos del Registro Nacional de Prestadores Individuales de Salud.</small>
                        <hr className="division-prestador"/>

                        </div>

                        {/* METODOS */}
                        <div className="col-12 col-lg-3 my-5">
                            <h6>MÉTODOS</h6>
                            <ul className="list-group text-center">
                                <li className={Metodos === 0 ? 'list-group-itemm active' : 'list-group-itemm'} onClick={() => ChangeMetod()}>/api/prestadores/rut/</li>
                                <li className={Metodos === 1 ? 'list-group-itemm active' : 'list-group-itemm'} onClick={() => ChangeMetod()}>/api/prestadores/registro/</li>
                            </ul>
                        </div>

                        {/* DETALLES DEL METODO /prestadores/antecedentes/{'{rut}'} */}
                        <div className="col-12 col-lg-4 my-5">
                            <p className="font-weight-bolder">DETALLES DEL MÉTODO</p>

                            <a className="btn-prest text-uppercase mt-4 d-block" data-toggle="collapse" href="#descripcion" role="button" aria-expanded="false" aria-controls="descripcion">
                               <span className="titulo-metodo text-primary">+</span> Descripción
                            </a>
                            <div className="collapse show mt-2 contenido-small" id="descripcion">
                                <p className="text-muted">{ Metodos === 0 ? 'Permite consultar los antecedentes de un médico según RUT.' : 'Permite consultar los antecedentes de un médico según Número Registro.' }</p>
                            </div>
                            
                            <a className="btn-prest text-uppercase mt-5 d-block" data-toggle="collapse" href="#origen" role="button" aria-expanded="false" aria-controls="origen">
                            <span className="titulo-metodo text-primary">+</span> origen
                            </a>
                            <div className="collapse show mt-2 contenido-small" id="origen">
                                <p className="text-muted ml-3 d-flex">GET<small className="ml-auto mr-4">{ Metodos === 0 ? '/api/prestadores/rut/' : '/api/prestador/registro/'}</small></p>
                            </div>

                            <a className="btn-prest text-uppercase mt-5 d-block" data-toggle="collapse" href="#objetivo-nivel" role="button" aria-expanded="false" aria-controls="objetivo-nivel">
                            <span className="titulo-metodo text-primary">+</span> OBJETIVO DE NIVEL DE SERVICIO (SLO)
                            </a>
                            <div className="collapse show mt-2 contenido-small" id="objetivo-nivel">
                                <p className="text-muted ml-3 d-flex">Tiempos de respuesta<small className="ml-auto mr-4"> 100000 ms</small></p>
                                <p className="text-muted ml-3 d-flex">Disponibilidad<small className="ml-auto mr-4"> 96 %</small></p>
                                <p className="text-muted ml-3 d-flex">Frecuencia de comprobación del estado de los métodos<small className="ml-auto mr-4"> 60 min</small></p>
                            </div>

                            <a className="btn-prest text-uppercase mt-5 d-block" data-toggle="collapse" href="#limites" role="button" aria-expanded="false" aria-controls="limites">
                            <span className="titulo-metodo text-primary">+</span> límites
                            </a>

                            <div className="collapse show mt-2 contenido-small" id="limites">
                            <p className="text-muted">Número de llamadas que los métodos manejaran</p>

                                <p className="text-muted ml-3 d-flex">Por segundo<small className="ml-auto mr-4 "> 9 </small></p>
                                <p className="text-muted ml-3 d-flex">Por minuto<small className="ml-auto mr-4 "> 100 </small></p>
                                <p className="text-muted ml-3 d-flex">Por hora<small className="ml-auto mr-4 "> 10000 </small></p>
                                <p className="text-muted ml-3 d-flex">Por día<small className="ml-auto mr-4 "> 30000 </small></p>
                                <p className="text-muted ml-3 d-flex">Por mes<small className="ml-auto mr-4 "> 100000 </small></p>
                                <p className="text-muted ml-3 d-flex">Por año<small className="ml-auto mr-4 "> 3000000 </small></p>

                            <p className=" text-muted">MB que los métodos transmitirán (entrante y saliente)</p>
                            <div className="collapse show mt-2 contenido-small" id="limites">
                                <p className="text-muted ml-3 d-flex">Por segundo<small className="ml-auto mr-4"> 10 </small></p>
                                <p className="text-muted ml-3 d-flex">Por minuto<small className="ml-auto mr-4"> 50 </small></p>
                                <p className="text-muted ml-3 d-flex">Por hora<small className="ml-auto mr-4"> 200 </small></p>
                                <p className="text-muted ml-3 d-flex">Por día<small className="ml-auto mr-4"> 500 </small></p>
                                <p className="text-muted ml-3 d-flex">Por mes<small className="ml-auto mr-4"> 1000 </small></p>
                                <p className="text-muted ml-3 d-flex">Por año<small className="ml-auto mr-4"> 5000 </small></p>
                            </div>

                            <p className=" text-muted">Tiempo que los métodos esperaran una respuesta:</p>
                            <div className="collapse show mt-2 contenido-small" id="limites">
                                <p className="text-muted ml-3 d-flex">En milisegundos<small className="ml-auto mr-4"> 60000 </small></p>
                            </div>

                            <p className=" text-muted">Tiempo que la respuesta de los métodos será guardada en cache</p>
                            <div className="collapse show mt-2 contenido-small" id="limites">
                                <p className="text-muted ml-3 d-flex">En milisegundos<small className="ml-auto mr-4"> 360000 </small></p>
                                <p className="text-muted ml-3 d-flex">Número máximo de filas que los métodos retornarán en una sola llamada<small className="ml-auto mr-4"> 50 </small></p>
                            </div>
                            </div>
                            
                            <a className="btn-prest text-uppercase mt-5 d-block" data-toggle="collapse" href="#odiccionario" role="button" aria-expanded="false" aria-controls="odiccionario">
                            <span className="titulo-metodo text-primary">+</span> diccionario de datos
                            </a>
                            <div className="collapse show mt-2 contenido-small" id="odiccionario">
                                <p className="text-muted ml-3 d-flex">Ninguno</p>
                            </div>
                        </div>
                        {/* DETALLES DEL METODO /prestadores/antecedentes/{'{rut}'} */}
                        
                        {/* DETALLES DE UNA SOLICITUD /prestadores/antecedentes/rut */}
                        <div className="col-12 col-lg-4 my-5">
                            <p className="font-weight-bolder">DETALLE DE UNA SOLICITUD</p>

                            <div className="div-json">
                                <button className="btn ml-3 mt-3 font-weight-bold d-inline btn-json" onClick={FormatoJson} disabled={FormatJson === 0 ? true : false}>JSON</button>
                                <button className="btn ml-3 mt-3 font-weight-bold d-inline btn-json" onClick={FormatoJson}  disabled={FormatJson === 1 ? true : false}>HL7</button>
                                <pre className="text-prestador-json col-12" >{FormatJson === 0 ? textedJson : hl7Json}</pre>
                            </div>

                            <button type="button" className="btn btn-primary mb-2 mt-5" data-toggle="modal" data-target="#exampleModal" onClick={() => ProbarMetodo()}>PRUEBA ESTE METODO</button>
                            
                             <p className="font-weight-bolder">FRAGMENTOS DE CÓDIGO</p>

                            <p>Elegir Formato: 
                                <button className={ClassFormat === true ? "btn btn-outline-success btn-sm-api font-weight-bold d-inline m-1 formatactive" : 'btn btn-outline-success btn-sm-api font-weight-bold d-inline m-1 '} onClick={ChangeFormat}>JSON</button>

                                <button className={ClassFormat === false ? "btn btn-outline-success btn-sm-api font-weight-bold d-inline m-1 formatactive" : 'btn btn-outline-success btn-sm-api font-weight-bold d-inline m-1 '} onClick={ChangeFormat}>HL7</button>
                            </p>

                            <div className="div-json-code">
                                <div className=" my-2 ml-2">
                                    {lenguajes1.map(lenguaje => 

                                        <button key={lenguaje} className="btn btn-secondary btn-sm font-weight-bold d-inline btn-json m-1" onClick={() =>setLenguaje(lenguaje)} id={lenguaje}>{lenguaje} </button>
                                        
                                    )}
                                </div>
                                
                                <div className="ml-2">
                                    {lenguajes2.map(lenguaje => 
                                        <button key={lenguaje} className="btn btn-secondary btn-sm font-weight-bold d-inline btn-json m-1" onClick={() =>setLenguaje(lenguaje)} id={lenguaje}>{lenguaje}</button>
                                    )}
                                </div>

                                <div className="p-2">
                                    <code className="code-api">
                                        
                                        {Lenguaje === 'cURL' ?
                                        
                                        <>
                                            <p className="mb-0">curl --request GET \</p>
                                            <span className="code-api-red">{process.env.REACT_APP_ENLACE_EXT+"prestadores/rut/12950968."+Format+"/?apikey=YOUR_AUTH_KEY"}</span> 
                                        </>
                                        : Lenguaje === 'Python' ?

                                        <>
                                            <p className="mb-0"><span className="code-attribute">import</span> requests</p>
                                            <p ><span className="code-attribute">import</span> json</p>

                                            <p>response = requests.get(<span className="code-api-red">{process.env.REACT_APP_ENLACE_EXT+"prestadores/rut/13029926."+Format+"/?apikey=YOUR_AUTH_KEY"}</span>)</p>

                                            <p>print(response.json())</p> 
                                        </>
                                        : Lenguaje === 'R' ?
                                        
                                        <>
                                            <p className="code-attribute mb-0">require<span className="code-api-red">("httr")</span></p>
                                            <p className="code-attribute">require<span className="code-api-red">("jsonlite")</span></p>

                                            <p>response {"<-"} GET( url = <span className="code-api-red">{process.env.REACT_APP_ENLACE_EXT+"prestadores/rut/13029926."+Format+"/?apikey=YOUR_AUTH_KEY"}</span>)</p>
                                            <p className="mb-0">response_text {"<-"} content(get_prices,"text")</p>
                                            <p className="mb-0">response_json {"<-"} fromJSON(get_prices_text)</p>
                                            <p className="mb-0">response_json</p>

                                        </>
                                        : Lenguaje === 'Java' ?

                                        <div>
                                            {Parser(htmlJava)}
                                        </div>

                                        : Lenguaje === 'PHP' ?

                                        <div>
                                            {Parser(htmlPhp)}
                                        </div>

                                        : Lenguaje === 'Ruby' ?

                                        <div>
                                            {Parser(htmlRuby)}
                                        </div>

                                        :Lenguaje === 'Node' ?

                                        <div>
                                            {Parser(htmlNode)}
                                        </div>

                                        :Lenguaje === 'Go' ?

                                        <div>
                                            {Parser(htmlGo)}
                                        </div>

                                        :Lenguaje === 'Swift' ?

                                        <div>
                                            {Parser(htmlSwift)}
                                        </div>

                                        :Lenguaje === 'C#' ?

                                        <div>
                                            {Parser(htmlC)}
                                        </div>

                                        :null}

                                    </code>
                                </div>
                                {/* <button className="btn btn-primary" onClick={CopiarClip}>Copiar</button> */}
                            </div> 

                        </div>

                        {/* DETALLES DE UNA SOLICITUD /prestadores/antecedentes/rut */}

                    </div>
                </div>
            </div>

            <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">PROBAR MÉTODO</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-5">
                                <a className="btn-prest text-uppercase mt-4 d-block" data-toggle="collapse" href="#url-probar" role="button" aria-expanded="false" aria-controls="url-probar">
                                <span className="titulo-metodo text-primary">+</span> URL
                                </a>
                                <div className="collapse show mt-2 contenido-small" id="url-probar">
                                    
                                <div className="d-flex my-1">
                                    <button className="d-inline btn btn-primary input-parametros text-center">GET</button>
                                </div>
                                <div className="d-flex my-1">
                                    <small className="url-metod p-2  input-parametros text-center">{ Metodos === 0 ? '/api/prestadores/rut/' : '/api/prestadores/registro/'}</small>
                                </div>

                                </div>
                                
                                <a className="btn-prest text-uppercase mt-4 d-block" data-toggle="collapse" href="#parametros-probar" role="button" aria-expanded="false" aria-controls="parametros-probar">
                                <span className="titulo-metodo text-primary">+</span> PÁRAMETROS
                                </a>
                                <div className="collapse show  contenido-small" id="parametros-probar">
                                    <p className="text-muted contenido-small">PÁRAMETROS EN RUTA</p>
                                    <form id="form-probar">
                                    {Metodos === 0 ? 
                                    <>
                                        <div className="d-flex mb-1">
                                            <button className="btn btn-primary btn-probar input-parametros" type="button">RUT</button>
                                        </div>

                                        <div className="d-flex my-1">
                                            <input type="text" className="url-metod p-2 dato input-parametros text-center" id="rutpres" name="rutpres" min="1" onChange={MetodoPrestador} onKeyDown={(e) => Numeros(e)} placeholder={12950968} value={datos_metodo_prestador.rutpres ? datos_metodo_prestador.rutpres : ""}/>
                                        </div>
                                    </>
                                    :
                                    <>
                                        
                                    <div className="d-flex my-1">
                                        <button className="btn btn-primary btn-probar input-parametros text-center" type="button">Registro</button>
                                    </div>
                                    <div className="d-flex my-1">
                                        <input type="text" className="url-metod p-2 dato input-parametros text-center" name="nroregistro" min="1" onChange={MetodoPrestador}  placeholder={334583} onKeyDown={(e) => Numeros(e)} value={datos_metodo_prestador.nroregistro ? datos_metodo_prestador.nroregistro : ""}/>
                                    </div>
                                    </>
                                    }
                                    </form>
                                </div>
                                
                                <a className="btn-prest text-uppercase mt-4 d-block" data-toggle="collapse" href="#formato-json" role="button" aria-expanded="false" aria-controls="formato-json">
                                <span className="titulo-metodo text-primary">+</span> FORMATO DE RESPUESTA
                                </a>
                                <div className="collapse show  contenido-small mt-2" id="formato-json">
                                    <div className="form-check form-check-inline ">
                                        <input className="form-check-input" type="radio" name="formato_json" value={"json"} checked={datos_metodo_prestador.formato_json === "json" ? true : false} onChange={ChangeFormato} id="inlineRadio1"/>
                                        <label className="form-check-label" htmlFor="inlineRadio1">JSON</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="formato_json" value={"hl7"} checked={datos_metodo_prestador.formato_json === "hl7" ? true : false} onChange={ChangeFormato} id="inlineRadio2" />
                                        <label className="form-check-label" htmlFor="inlineRadio2">HL7</label>
                                    </div>
                                </div>

                                <a className="btn-prest text-uppercase mt-3 d-block" data-toggle="collapse" href="#auth-probar" role="button" aria-expanded="false" aria-controls="auth-probar">
                                <span className="titulo-metodo text-primary">+</span> AUTH KEY
                                </a>
                                <div className="collapse show mt-2 contenido-small" id="auth-probar">
                                    
                                <div className="d-flex my-1">
                                    <button className="d-inline btn btn-primary input-parametros text-center">KEY</button>
                                </div>
                                
                                <div className="d-flex my-1">
                                    <small className="url-metod p-2 input-parametros text-center"> {apikey}</small>
                                </div>
                                    
                                </div>
                                
                                <button className="btn btn-primary my-5 col-12" type="button" onClick={ConsultaApi}>Ejecutar</button>

                                {AlertaProbar ? 
                                    <div className="alert alert-warning col-12 text-center" role="alert">
                                        <strong>{Metodos === 0 ? "El campo rut es obligatorio.": "El campo nro registro es obligatorio."}</strong>
                                    </div>
                                :null}
                            </div>
                            
                            <div className="col-12 col-lg-7 ">
                                <a className="btn-prest text-uppercase mt-4 d-block" data-toggle="collapse" href="#url-form" role="button" aria-expanded="false" aria-controls="url-form">
                                <span className="titulo-metodo text-primary">+</span> URL CON FORMATO
                                </a>
                                <div className="collapse show mt-2 contenido-small row align-items-center" id="url-form">
                               
                                {datos_metodo_prestador.formato_json === 'json' ? 
                                    <pre className="url-metod p-2 col-12 col-lg-9 pre-url my-1">
                                       {Metodos === 0 ? `${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/${ValueRut ? ValueRut : "12950968"}.json/?apikey=${apikey}` : `${process.env.REACT_APP_ENLACE_EXT}prestadores/registro/${ValueNro ? ValueNro : "334593"}.json/?apikey=${apikey}`}
                                    </pre>
                                : 
                                    <pre className="url-metod p-2 col-12 col-lg-9 pre-url my-1">
                                        {Metodos === 0 ? `${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/${ValueRut ? ValueRut : "12950968"}.hl7/?apikey=${apikey}` : `${process.env.REACT_APP_ENLACE_EXT}prestadores/registro/${ValueNro ? ValueNro : "334593"}.hl7/?apikey=${apikey}`}
                                    </pre>
                                }

                                </div>
                                
                                <a className="btn-prest text-uppercase mt-4 d-block" data-toggle="collapse" href="#respuesta" role="button" aria-expanded="false" aria-controls="respuesta">
                                <span className="titulo-metodo text-primary">+</span> RESPUESTA
                                </a>
                                <div className="collapse show mt-2 contenido-small" id="respuesta">
                                    
                                    {consulta_prestadores === true ? 
                                        <div className="spinner-grow text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    :
                                    <>
                                        {respuesta_api_prestadores === 200 ? 
                                        <button className="btn btn-outline-success font-weight-bold">200</button>
                                        : respuesta_api_prestadores === 204 ? 
                                    
                                        <button className="btn btn-outline-danger font-weight-bold">204</button>
                                        :respuesta_api_prestadores === 404 ? 
                                    
                                        <button className="btn btn-outline-danger font-weight-bold">404</button>
                                        :null}
                                        <pre className="text-prestador-json-modal col-12 mt-2 d-flex" >

                                            {consulta_prestadores ? 
                                                <div className="spinner-border mx-auto my-auto" role="status">
                                                </div> 
                                            :
                                            
                                                json_resp
                                            }
                                        </pre>
                                    </>
                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                
                </div>
            </div>
            </div>

            <Footer/>
        </>

     );
}
 
export default PrestadorAPI;